// Headless export registration for MaxDiff (`md`). MaxDiffChart renders through
// ChartContainer (Phase 2 hook covers it); this only maps the payload. answer is the
// raw per-item coeff object (b{n}:{varyingProbability,probability,raw}); the component
// builds hcAnswers itself. viewMode is required (varyingProbability/probability/raw).
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/03-highcharts-rollout.md §4.2

import { commonHcProps, registerHc } from '@aytm/app/stats/page/question-views/components/charts/lib/hc-exportable'

import MaxDiffChart from '@aytm/app/stats/page/question-views/md/components/chart/Chart'

registerHc(['md'], MaxDiffChart, (data: any, params: any) => ({
  ...commonHcProps(data, params),
  // view-selection → params
  viewMode: params.viewMode,
  modelChartMode: params.modelChartMode,
  zoomLevel: params.zoomLevel,
  globalZoomLevel: params.globalZoomLevel,
  confidenceLevel: params.confidenceLevel,
  confidenceLevels: params.confidenceLevels,
  // question config → data
  itemsPerSet: data.itemsPerSet,
  // no zoom interaction in headless
  onZoomChange: () => {}
}))
